export const isGeneralTenantCase = (caseData: any) =>
	!!caseData?.generalTenantCaseType;
